<template>
    <div
        v-if="GET_SHOW_ZOOMED_MODAL"
        style="
            position: fixed;
            top: 0;
            left: 0;
            padding-top: 20px;
            height: 100%;
            width: 100vw;
            z-index: 4000;
            background-color: #000;
        "
    >
        <div class="d-flex justify-content-end px-2">
            <WhiteIconButton
                icon="x-circle"
                :tooltip="$t('dam-profile.icon.reset')"
                :emit-this="'close'"
                v-on:close="TOGGLE_ZOOM_MODAL"
            ></WhiteIconButton>
        </div>
        <v-zoomer
            ref="zoomer"
            style="
                height: 100%;
                width: 100%;
                max-height: 80vh;
                max-width: 100vw;
            "
            :max-scale="10"
            :zooming-elastic="false"
            :zoomed.sync="zoomed"
            :mouseWheelToZoom="true"
            :doubleClickToZoom="false"
        >
            <img
                :src="GET_IMAGE_SRC"
                style="
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                "
            />
        </v-zoomer>
        <div class="d-flex justify-content-center">
            <WhiteIconButton
                icon="zoom-in"
                :tooltip="$t('dam-profile.icon.zoom-in')"
                :emit-this="'zoom-in'"
                v-on:zoom-in="$refs.zoomer.zoomIn()"
            ></WhiteIconButton>
            <WhiteIconButton
                icon="zoom-out"
                :tooltip="$t('dam-profile.icon.zoom-out')"
                :emit-this="'zoom-out'"
                v-on:zoom-out="$refs.zoomer.zoomOut()"
            ></WhiteIconButton>
            <WhiteIconButton
                :tooltip="$t('dam-profile.icon.reset')"
                :emit-this="'reset'"
                icon="zoom-search"
                :text="this.$i18n.t('dam-profile.icon.reset')"
                :disabled="!zoomed"
                v-on:reset="$refs.zoomer.reset(-1)"
            ></WhiteIconButton>
        </div>
    </div>
</template>

<script>
    // vuex
    import { mapGetters, mapActions } from "vuex";
    import { GET_SHOW_ZOOMED_MODAL, GET_IMAGE_SRC, TOGGLE_ZOOM_MODAL } from "../../store/actions/profile";
    // components
    import WhiteIconButton from "./WhiteIconButton";

    export default {
        name: "CarouselGalleryZoomer",
        components: {
            WhiteIconButton
        },
        data() {
            return {
                selIndex: 0,
                zoomed: false
            }
        },
        computed: {
            ...mapGetters([GET_SHOW_ZOOMED_MODAL, GET_IMAGE_SRC]),
            isShown() {
                return this.GET_SHOW_ZOOMED_MODAL
            },
        },
        methods: {
            ...mapActions([TOGGLE_ZOOM_MODAL]),
            handlePrev() {
                this.selIndex -= 1;
            },
            handleNext() {
                this.selIndex += 1;
            },
            /**
             * Handles closing the modal on ESC click
             */
            handleKeyBoardKeys(event) {
                if (event.keyCode === 27 && this.GET_SHOW_ZOOMED_MODAL) {
                    this.TOGGLE_ZOOM_MODAL();
                }
            }
        },
        mounted() {
            document.body.addEventListener('keyup', this.handleKeyBoardKeys);
        },
        destroyed() {
            document.body.removeEventListener('keyup', this.handleKeyBoardKeys);
        }
    }
</script>

<style lang="scss" scoped>
</style>